import { render, staticRenderFns } from "./ErrorForbidden.vue?vue&type=template&id=750b86cc&scoped=true&"
import script from "./ErrorForbidden.vue?vue&type=script&lang=js&"
export * from "./ErrorForbidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b86cc",
  null
  
)

export default component.exports